import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=a3d9daba"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports